import SVG, { IconProps } from '@icons/svg'

const IconBackRef = (props: IconProps) => (
	<SVG aria-label="Back Reference" {...props}>
		<path d="M7.00199 18.998C7.39199 18.608 7.39199 17.978 7.00199 17.588L6.12199 16.708H15.292C18.602 16.708 21.292 14.018 21.292 10.708C21.292 7.39801 18.602 4.70801 15.292 4.70801H11.292C10.742 4.70801 10.292 5.15801 10.292 5.70801C10.292 6.25801 10.742 6.70801 11.292 6.70801H15.292C17.502 6.70801 19.292 8.49801 19.292 10.708C19.292 12.918 17.502 14.708 15.292 14.708H6.12199L7.00199 13.828C7.39199 13.438 7.39199 12.808 7.00199 12.418C6.61199 12.028 5.98199 12.028 5.59199 12.418L3.00199 15.008C2.61199 15.398 2.61199 16.028 3.00199 16.418L5.59199 19.008C5.97199 19.388 6.61199 19.388 7.00199 18.998Z" />
	</SVG>
)

export default IconBackRef
